import React from 'react';
import CommunityViewNew from './CommunityViewNew';

/**
 * Variante C: tarjeta de horarios **arriba de Productos** (columna izquierda
 * de la card grid, ocupando todo el ancho de esa columna span-2).
 *
 * URL: /communities3/:id
 */
export default function CommunityView3() {
  return <CommunityViewNew scheduleCardPlacement="above-products" />;
}
